(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var SECTION = 'cart-drawer';
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || drawer.dataset.init) return;
    drawer.dataset.init = '1';
    var content = drawer.querySelector('[data-cart-content]');

    function open() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
    function close() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }

    function updateCounts(n) {
      document.querySelectorAll('.header__cart-count').forEach(function (el) { el.textContent = n; el.classList.toggle('is-empty', n === 0); });
      var dc = drawer.querySelector('[data-drawer-count]'); if (dc) dc.textContent = n;
    }
    function render(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nc = doc.querySelector('[data-cart-content]');
      if (nc && content) content.innerHTML = nc.innerHTML;
      var dc = doc.querySelector('[data-drawer-count]');
      if (dc) updateCounts(parseInt(dc.textContent, 10) || 0);
    }
    function renderFromSections(sections) { if (sections && sections[SECTION]) render(sections[SECTION]); }

    function change(key, qty) {
      drawer.classList.add('is-loading');
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: SECTION, sections_url: location.pathname })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        renderFromSections(cart.sections);
        updateCounts(cart.item_count);
        drawer.classList.remove('is-loading');
      }).catch(function () { drawer.classList.remove('is-loading'); });
    }

    // Open from header cart icon; close from overlay / close buttons
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-toggle], .header__cart')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

    // Quantity / remove (delegated within the drawer)
    drawer.addEventListener('click', function (e) {
      var line = e.target.closest('[data-key]');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var valEl = line.querySelector('[data-cart-qty]');
      var v = valEl ? (parseInt(valEl.textContent, 10) || 1) : 1;
      if (e.target.closest('[data-cart-plus]')) change(key, v + 1);
      else if (e.target.closest('[data-cart-minus]')) change(key, Math.max(0, v - 1));
      else if (e.target.closest('[data-cart-remove]')) change(key, 0);
    });

    // Open + refresh when an item is added elsewhere (product page)
    document.addEventListener('cart:added', function (e) {
      if (e.detail && e.detail.sections) renderFromSections(e.detail.sections);
      if (e.detail && e.detail.item_count != null) updateCounts(e.detail.item_count);
      open();
    });

    window.CartDrawer = { open: open, close: close };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var page = document.querySelector('[data-cart-page]');
    if (!page || page.dataset.init) return;
    page.dataset.init = '1';
    var sectionId = page.getAttribute('data-section-id');
    var content = page.querySelector('[data-cart-content]');

    function updateCounts(n) {
      document.querySelectorAll('.header__cart-count').forEach(function (el) { el.textContent = n; el.classList.toggle('is-empty', n === 0); });
      var dc = document.querySelector('[data-drawer-count]'); if (dc) dc.textContent = n;
    }
    function render(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nc = doc.querySelector('[data-cart-content]');
      if (nc && content) content.innerHTML = nc.innerHTML;
    }
    function change(key, qty) {
      page.classList.add('is-loading');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: sectionId, sections_url: '/cart' })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        if (cart.sections && cart.sections[sectionId]) render(cart.sections[sectionId]);
        updateCounts(cart.item_count);
        page.classList.remove('is-loading');
      }).catch(function () { page.classList.remove('is-loading'); location.reload(); });
    }
    page.addEventListener('click', function (e) {
      var line = e.target.closest('[data-key]');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var valEl = line.querySelector('[data-cart-qty]');
      var v = valEl ? (parseInt(valEl.textContent, 10) || 1) : 1;
      if (e.target.closest('[data-cart-plus]')) change(key, v + 1);
      else if (e.target.closest('[data-cart-minus]')) change(key, Math.max(0, v - 1));
      else if (e.target.closest('[data-cart-remove]')) change(key, 0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-modals"]) return;
  try {
    
  (function () {
    var modals = document.querySelectorAll('[data-modal]');
    if (!modals.length || document.body.dataset.modalsInit) return;
    document.body.dataset.modalsInit = '1';


    // The old dropdown pickers are gone; these stubs keep closeAll / Esc happy.
    var pickers = [];
    function closePickers() {}

    // ---- opening hours: each location carries data-avail="Mon-Fri 11:00-20:00 ; Sat-Sun 15:00-18:00" ----
    var DAY = { sun: 0, mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6 };
    var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var RULE_RE = /^(.+?)\s+(\d{1,2}):(\d{2})\s*-\s*(\d{1,2}):(\d{2})$/;
    function parseDays(spec) {
      spec = (spec || '').toLowerCase().replace(/[–—]/g, '-').replace(/\s+/g, '');
      if (!spec || spec === 'everyday' || spec === 'daily' || spec === 'all') return [0, 1, 2, 3, 4, 5, 6];
      var out = [], key = function (t) { return DAY[t.slice(0, 3)]; };
      spec.split(',').forEach(function (part) {
        var r = part.split('-'), d;
        if (r.length === 2 && key(r[0]) !== undefined && key(r[1]) !== undefined) {
          var a = key(r[0]), b = key(r[1]);
          if (a <= b) { for (d = a; d <= b; d++) out.push(d); }
          else { for (d = a; d <= 6; d++) out.push(d); for (d = 0; d <= b; d++) out.push(d); }
        } else if (key(part) !== undefined) { out.push(key(part)); }
      });
      return out;
    }
    function parseAvail(str) {
      var rules = [];
      (str || '').split(';').forEach(function (seg) {
        var m = seg.trim().replace(/[–—]/g, '-').match(RULE_RE);
        if (m) rules.push({ label: m[1].replace(/\s*-\s*/g, '–'), days: parseDays(m[1]), start: +m[2] + (+m[3]) / 60, end: +m[4] + (+m[5]) / 60 });
      });
      return rules;
    }
    function clock(h, short) {
      var hh = Math.floor(h), mm = Math.round((h - hh) * 60), ap = (hh >= 12 && hh < 24) ? 'PM' : 'AM', d = hh % 12;
      if (d === 0) d = 12;
      if (short) return d + (mm ? ':' + (mm < 10 ? '0' : '') + mm : '') + ap.toLowerCase();
      return d + ':' + (mm < 10 ? '0' : '') + mm + ' ' + ap;
    }
    // one-off closures on top of the weekly hours: data-closed="2026-10-31 to 2026-11-01, 2026-12-25"
    var CLOSED_RE = /^(\d{4}-\d{2}-\d{2})(?:\s*(?:to|-|–|—|\.\.)\s*(\d{4}-\d{2}-\d{2}))?$/i;
    function parseClosed(str) {
      var set = {};
      (str || '').split(/[,;\n]/).forEach(function (part) {
        var m = part.trim().match(CLOSED_RE);
        if (!m) return;
        var d = fromYmd(m[1]), end = fromYmd(m[2] || m[1]);
        for (var n = 0; d <= end && n < 366; n++, d = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1)) set[ymd(d)] = 1;
      });
      return set;
    }
    // closed dates from today on, as runs of consecutive days [[first, last], ...] — past ones drop out by themselves
    function closedRuns(set) {
      var today = ymd(new Date()), runs = [];
      Object.keys(set).filter(function (k) { return k >= today; }).sort().forEach(function (k) {
        var d = fromYmd(k), last = runs[runs.length - 1];
        if (last && ymd(new Date(last[1].getFullYear(), last[1].getMonth(), last[1].getDate() + 1)) === k) last[1] = d;
        else runs.push([d, d]);
      });
      return runs;
    }
    // a new location's opening day, data-opens="2026-11-06"; '' once it is today or past
    function opensLater(str) {
      str = (str || '').trim();
      return /^\d{4}-\d{2}-\d{2}$/.test(str) && str > ymd(new Date()) ? str : '';
    }
    function runLabel(r, dow) {
      var a = r[0], b = r[1], w = function (d) { return dow ? DOW[d.getDay()] + ' ' : ''; };
      if (sameDay(a, b)) return w(a) + a.getDate() + ' ' + MON[a.getMonth()];
      if (a.getMonth() === b.getMonth()) return w(a) + a.getDate() + ' – ' + w(b) + b.getDate() + ' ' + MON[b.getMonth()];
      return w(a) + a.getDate() + ' ' + MON[a.getMonth()] + ' – ' + w(b) + b.getDate() + ' ' + MON[b.getMonth()];
    }
    function hoursLabel(rules) {
      return rules.map(function (r) { return r.label + ' ' + clock(r.start, true) + '–' + clock(r.end, true); }).join(' · ');
    }
    // first slot is the opening time, then every whole hour until half an hour before closing
    function slotsFor(rules, date) {
      var wd = date.getDay(), set = {};
      var day = rules.length ? rules.filter(function (r) { return r.days.indexOf(wd) >= 0; }) : [{ start: 9, end: 17 }];
      day.forEach(function (r) {
        set[r.start] = 1;
        for (var h = Math.floor(r.start) + 1; h <= r.end - 0.5 + 1e-9; h++) set[h] = 1;
      });
      var slots = Object.keys(set).map(Number).sort(function (a, b) { return a - b; });
      var now = new Date();
      if (sameDay(date, now)) {
        var cut = now.getHours() + now.getMinutes() / 60 + 1;
        slots = slots.filter(function (h) { return h >= cut; });
      }
      return slots;
    }
    function sameDay(a, b) { return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate(); }
    function ymd(d) { return d.getFullYear() + '-' + (d.getMonth() < 9 ? '0' : '') + (d.getMonth() + 1) + '-' + (d.getDate() < 10 ? '0' : '') + d.getDate(); }
    function fromYmd(s) { var p = s.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }
    function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

    // ---- booking sheet ----
    var bookingForm = document.getElementById('BookingForm');
    var bk = bookingForm && bookingForm.querySelector('[data-bk-main]') ? bookingForm : null;
    var bkApi = { select: function () {} };
    if (bk) (function () {
      var locInputs = [].slice.call(bk.querySelectorAll('input[name="contact[Showroom / pickup point]"]'));
      var dateValue = bk.querySelector('[data-bk-date-value]');
      var whenEmpty = bk.querySelector('[data-bk-when-empty]');
      var whenBox = bk.querySelector('[data-bk-when]');
      var datesBox = bk.querySelector('[data-bk-dates]');
      var timesBox = bk.querySelector('[data-bk-times]');
      var sum = {
        loc: document.querySelector('[data-bk-sum="loc"]'),
        when: document.querySelector('[data-bk-sum="when"]')
      };
      var current = null;  // the checked location input
      var closed = {};     // its one-off closed dates, keyed YYYY-MM-DD
      var opensOn = '';    // its opening day if it hasn't opened yet
      var main = bk.querySelector('[data-bk-main]');
      var msum = bk.querySelector('[data-bk-msum]');
      var phone = window.matchMedia ? window.matchMedia('(max-width: 859px)') : { matches: false };
      // phones: after a choice, bring the next thing into view (only ever scrolls down)
      function nudge(el) {
        if (!phone.matches || !el || !main) return;
        var top = el.getBoundingClientRect().top - main.getBoundingClientRect().top;
        if (top > main.clientHeight * 0.55) main.scrollTo({ top: main.scrollTop + top - 16, behavior: 'smooth' });
      }
      function updateMsum() {
        if (!msum) return;
        var bits = [];
        if (current) bits.push(city());
        if (dateValue.value) bits.push(dayLabel(fromYmd(dateValue.value)));
        var tm = (timesBox.querySelector('input:checked') || {}).value;
        if (tm) bits.push(tm === "I'm flexible" ? 'flexible time' : tm);
        msum.textContent = bits.join(' · ');
        msum.hidden = !bits.length;
      }

      locInputs.forEach(function (inp) {
        var card = inp.closest('.bk__loc');
        var hours = card.querySelector('[data-bk-hours]');
        if (hours) hours.textContent = hoursLabel(parseAvail(inp.getAttribute('data-avail')));
        var tag = card.querySelector('[data-bk-closed-tag]');
        var opens = opensLater(inp.getAttribute('data-opens'));
        var runs = closedRuns(parseClosed(inp.getAttribute('data-closed')));
        if (tag && opens) { var od = fromYmd(opens); tag.textContent = 'Opens ' + od.getDate() + ' ' + MON[od.getMonth()]; tag.hidden = false; }
        else if (tag && runs.length) { tag.textContent = 'Closed ' + runs.map(function (r) { return runLabel(r); }).join(', '); tag.hidden = false; }
      });

      function msg(key, show) { var m = bk.querySelector('[data-bk-msg="' + key + '"]'); if (m) m.hidden = !show; }
      function setSum(key, text, empty) { if (sum[key]) { sum[key].textContent = text; sum[key].classList.toggle('is-empty', !!empty); } updateMsum(); }
      function rules() { return current ? parseAvail(current.getAttribute('data-avail')) : []; }
      function city() { return current ? current.getAttribute('data-bk-city') : ''; }
      function isOpen(date) { var r = rules(); return slotsFor(r, date).length > 0; }
      // a weekday the location never opens, or a one-off closed date (vs. today after the last slot, which is just skipped)
      function isClosedDay(date) { var r = rules(), k = ymd(date); return (opensOn && k < opensOn) || !!closed[k] || (r.length > 0 && !r.some(function (x) { return x.days.indexOf(date.getDay()) >= 0; })); }
      function showClosure() {
        var box = bk.querySelector('[data-bk-closure]');
        if (!box) return;
        var runs = closedRuns(closed), html = '';
        if (opensOn) {
          html = '<strong>Opens ' + esc(dayLabel(fromYmd(opensOn))) + '</strong>';
          var onote = current.getAttribute('data-closed-note') || '';
          if (onote) html += esc(onote);
        } else if (runs.length) {
          html = '<strong>Closed ' + esc(runs.map(function (r) { return runLabel(r, true); }).join(' and ')) + '</strong>';
          var note = current.getAttribute('data-closed-note') || '';
          if (note) html += esc(note) + ' ';
          // when it's back: the first open day after the closure. Only for a single closure —
          // with separate ones (e.g. Fri and Mon) the open days in between would read as closed.
          var end = runs[runs.length - 1][1];
          for (var i = 1; runs.length === 1 && i <= 14; i++) {
            var d = new Date(end.getFullYear(), end.getMonth(), end.getDate() + i);
            if (!isClosedDay(d) && isOpen(d)) { html += 'Open again from ' + dayLabel(d) + '.'; break; }
          }
        }
        box.innerHTML = html;
        box.hidden = !html;
      }
      function dayLabel(d) { return DOW[d.getDay()] + ' ' + d.getDate() + ' ' + MON[d.getMonth()]; }

      function chip(d, closed) {
        var v = ymd(d);
        return '<label class="bk__date' + (closed ? ' is-closed' : '') + '"' + (closed ? ' title="Closed"' : '') + '>' +
          '<input type="radio" class="bk__radio" name="bk_day" value="' + v + '"' + (closed ? ' disabled aria-label="' + dayLabel(d) + ', closed"' : '') + '>' +
          '<span class="bk__date-dow">' + (sameDay(d, new Date()) ? 'Today' : DOW[d.getDay()]) + '</span>' +
          '<span class="bk__date-day">' + d.getDate() + '</span>' +
          '<span class="bk__date-mon">' + MON[d.getMonth()] + '</span></label>';
      }
      function buildDates() {
        var keep = dateValue.value, html = '', first = null, d = new Date(), kept = false;
        d.setHours(0, 0, 0, 0);
        // consecutive days until 14 open ones; closed weekdays stay in the row, greyed and struck through
        for (var i = 0, shown = 0; i < 28 && shown < 14; i++) {
          var day = new Date(d.getFullYear(), d.getMonth(), d.getDate() + i);
          if (isClosedDay(day)) { html += chip(day, true); continue; }
          if (!isOpen(day)) continue;
          html += chip(day); shown++;
          if (ymd(day) === keep) kept = true;
        }
        if (!shown) html = '';
        datesBox.innerHTML = html || '<p class="bk__placeholder">No open days in the next few weeks — tell us when suits you in the note below.</p>';
        if (kept) { var r = datesBox.querySelector('input[value="' + keep + '"]'); if (r) r.checked = true; }
        else dateValue.value = '';
        buildTimes();
      }
      function buildTimes() {
        var v = dateValue.value;
        if (!v) { timesBox.hidden = true; timesBox.innerHTML = ''; return; }
        var keep = (timesBox.querySelector('input:checked') || {}).value || '';
        var slots = slotsFor(rules(), fromYmd(v)).map(function (h) { return clock(h); });
        var html = '';
        slots.forEach(function (t) { html += '<label class="bk__time"><input type="radio" class="bk__radio" name="contact[Preferred time]" value="' + esc(t) + '">' + t + '</label>'; });
        html += '<label class="bk__time bk__time--flex"><input type="radio" class="bk__radio" name="contact[Preferred time]" value="I\'m flexible">I\'m flexible</label>';
        timesBox.innerHTML = html;
        timesBox.hidden = false;
        if (keep) { var r = timesBox.querySelector('input[value="' + esc(keep) + '"]'); if (r) r.checked = true; }
        updateWhen();
      }
      function updateWhen() {
        var v = dateValue.value, t = (timesBox.querySelector('input:checked') || {}).value;
        if (!v) { setSum('when', 'Not chosen yet', true); return; }
        setSum('when', dayLabel(fromYmd(v)) + (t ? ' · ' + (t === "I'm flexible" ? 'flexible time' : t) : ''), false);
      }
      // fade at the bottom (or right edge on phones) of a long list until it's scrolled to the end
      function scrollCue(wrap) {
        if (!wrap || !wrap.classList.contains('is-many')) return;
        var endY = wrap.scrollTop + wrap.clientHeight >= wrap.scrollHeight - 2;
        var endX = wrap.scrollLeft + wrap.clientWidth >= wrap.scrollWidth - 2;
        wrap.classList.toggle('at-end', endY && endX);
      }
      [].slice.call(bk.querySelectorAll('[data-bk-scroll]')).forEach(function (w) {
        w.addEventListener('scroll', function () { scrollCue(w); }, { passive: true });
      });
      window.addEventListener('resize', function () {
        var w = bk.querySelector('[data-bk-display]:not([hidden]) [data-bk-scroll]');
        if (w) scrollCue(w);
      });
      function chooseLoc(inp) {
        current = inp;
        msg('loc', false);
        [].slice.call(bk.querySelectorAll('[data-bk-display]')).forEach(function (box) {
          var on = box.getAttribute('data-bk-display') === inp.getAttribute('data-bk-loc');
          box.hidden = !on;
        });
        var kind = inp.closest('.bk__loc').querySelector('.bk__loc-kind');
        var note = bk.querySelector('[data-bk-hours-note]');
        var hrs = hoursLabel(parseAvail(inp.getAttribute('data-avail')));
        if (note) note.textContent = hrs ? city() + ' opening hours: ' + hrs : '';
        closed = parseClosed(inp.getAttribute('data-closed'));
        opensOn = opensLater(inp.getAttribute('data-opens'));
        showClosure();
        setSum('loc', city() + (kind ? ' · ' + kind.textContent.trim() : ''), false);
        whenEmpty.hidden = true;
        whenBox.hidden = false;
        buildDates();
        var shown = bk.querySelector('[data-bk-display]:not([hidden])');
        if (shown) scrollCue(shown.querySelector('[data-bk-scroll]'));
        nudge(shown && shown.querySelector('.bk__chairs') ? shown : bk.querySelector('[data-bk-step="when"]'));
      }

      bk.addEventListener('change', function (e) {
        var t = e.target;
        if (t.name === 'contact[Showroom / pickup point]') chooseLoc(t);
        else if (t.name === 'bk_day') { dateValue.value = t.value; msg('date', false); buildTimes(); nudge(timesBox); }
        else if (t.name === 'contact[Preferred time]') { msg('time', false); updateWhen(); nudge(bk.querySelector('[data-bk-step="who"]')); }
      });
      // Long chair lists: "All" = first 9 + a "See all" tile (tap it to show the rest),
      // a brand filter = that brand in full.
      function showChairs(box, key, expand) {
        [].slice.call(box.querySelectorAll('[data-bk-brand]')).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-bk-brand') === key ? 'true' : 'false'); });
        [].slice.call(box.querySelectorAll('.bk__chairs > li')).forEach(function (li) {
          if (li.classList.contains('bk__more-li')) li.hidden = !!key || expand;
          else if (key) li.hidden = li.getAttribute('data-brand') !== key;
          else li.hidden = !expand && li.classList.contains('bk__extra');
        });
        var more = box.querySelector('[data-bk-expand]'), less = box.querySelector('[data-bk-collapse]');
        if (more) more.setAttribute('aria-expanded', !key && expand ? 'true' : 'false');
        if (less) less.hidden = !(!key && expand);
        var wrap = box.querySelector('[data-bk-scroll]');
        if (wrap && !expand) { wrap.scrollTop = 0; wrap.scrollLeft = 0; }
        scrollCue(wrap);
      }
      bk.addEventListener('click', function (e) {
        var brand = e.target.closest('[data-bk-brand]'), more = e.target.closest('[data-bk-expand]'), less = e.target.closest('[data-bk-collapse]');
        if (!brand && !more && !less) return;
        var box = (brand || more || less).closest('[data-bk-display]');
        if (brand) { showChairs(box, brand.getAttribute('data-bk-brand'), false); return; }
        if (less) {
          showChairs(box, '', false);
          var tile = box.querySelector('[data-bk-expand]');
          if (tile) { try { tile.focus({ preventScroll: true }); } catch (err) {} }
          var head = box.querySelector('.bk__display-head');
          if (head && main) { var top = head.getBoundingClientRect().top - main.getBoundingClientRect().top; if (top < 0) main.scrollTo({ top: main.scrollTop + top - 12, behavior: 'smooth' }); }
          return;
        }
        showChairs(box, '', true);
        var lessBtn = box.querySelector('[data-bk-collapse]');
        if (lessBtn) { try { lessBtn.focus({ preventScroll: true }); } catch (err) {} }
      });

      // Location, date and time are required; say which one is missing and scroll to it.
      bookingForm.addEventListener('submit', function (e) {
        var missing = [];
        if (!current) missing.push('loc');
        else {
          if (!dateValue.value) missing.push('date');
          if (!timesBox.querySelector('input:checked')) missing.push(dateValue.value ? 'time' : 'date');
        }
        ['loc', 'date', 'time'].forEach(function (k) { msg(k, missing.indexOf(k) >= 0); });
        var dm = bk.querySelector('[data-bk-msg="date"]');
        if (dm && missing.indexOf('date') >= 0) dm.textContent = 'Please pick a date.';
        if (missing.length) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var step = bk.querySelector('[data-bk-step="' + (missing[0] === 'loc' ? 'loc' : 'when') + '"]');
          if (step) step.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      });

      bkApi.select = function (name) {
        if (!name) return;
        name = String(name).toLowerCase();
        for (var i = 0; i < locInputs.length; i++) {
          if ((locInputs[i].getAttribute('data-bk-city') || '').toLowerCase() === name) {
            locInputs[i].checked = true; chooseLoc(locInputs[i]); return;
          }
        }
      };
      var pre = locInputs.filter(function (i) { return i.checked; })[0];
      if (pre) chooseLoc(pre);
    })();

    function open(name) {
      modals.forEach(function (m) {
        var on = m.getAttribute('data-modal') === name;
        m.classList.toggle('is-open', on);
        m.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.classList.toggle('bk-open', name === 'book');
      if (name === 'book') { requestAnimationFrame(function () { pickers.forEach(function (p) { p.refresh(); }); }); }
      var active = document.querySelector('[data-modal="' + name + '"].is-open');
      if (active) { var f = active.querySelector('input:not([type=hidden]), textarea, button'); if (f) try { f.focus(); } catch (e) {} }
    }
    function closeAll() {
      closePickers(null);
      modals.forEach(function (m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); });
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('bk-open');
    }

    document.addEventListener('click', function (e) {
      var book = e.target.closest('a[href$="#book"], [data-open-booking]');
      if (book) { e.preventDefault(); open('book'); bkApi.select(book.getAttribute('data-book-loc')); return; }
      var contact = e.target.closest('a[href$="#contact"], [data-open-contact]');
      if (contact) { e.preventDefault(); open('contact'); return; }
      if (e.target.closest('[data-modal-close]')) { e.preventDefault(); closeAll(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openTips = document.querySelectorAll('.bform__help.is-open');
      for (var i = 0; i < openTips.length; i++) openTips[i].classList.remove('is-open');
      var pickerOpen = false;
      for (var j = 0; j < pickers.length; j++) { if (pickers[j].el && pickers[j].el.classList.contains('is-open')) pickerOpen = true; }
      if (pickerOpen) { closePickers(null); return; }  // Esc closes an open dropdown first
      closeAll();
    });

    // Tapping anywhere outside an open dropdown closes it.
    document.addEventListener('click', function (e) { if (!e.target.closest('.picker')) closePickers(null); });

    // Help (?) tooltips — hover is CSS; this adds tap/click toggle on touch.
    document.addEventListener('click', function (e) {
      var help = e.target.closest('[data-help]');
      var openTips = document.querySelectorAll('.bform__help.is-open');
      for (var i = 0; i < openTips.length; i++) { if (openTips[i] !== help) openTips[i].classList.remove('is-open'); }
      if (help) help.classList.toggle('is-open');
    });

    // Tap-to-copy rows (e.g. WeChat ID)
    document.addEventListener('click', function (e) {
      var c = e.target.closest('[data-copy]');
      if (!c) return;
      var val = c.getAttribute('data-copy');
      var out = c.querySelector('[data-copy-val]');
      function done() { if (out) { var prev = out.textContent; out.textContent = 'Copied ✓'; setTimeout(function () { out.textContent = prev; }, 1400); } }
      if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(val).then(done).catch(done); } else { done(); }
    });

    // Open on initial load if URL hash matches (e.g. after a non-JS contact submit)
    if (location.hash === '#book') open('book');
    if (location.hash === '#contact') open('contact');

    // The booking form posts normally so Shopify's spam protection (reCAPTCHA) can attach
    // its token. After Shopify redirects back, re-open the modal to show the result.
    var bookModal = document.querySelector('[data-modal="book"]');
    if (bookModal && (bookModal.querySelector('.modal__done') || bookModal.querySelector('.bform__error'))) {
      open('book');
    }

    // Stamp hidden [data-attrib-input] fields (booking + contact forms) with first-touch
    // UTM / gclid / gbraid / wbraid / landing / referrer, so the notification email
    // shows where the enquiry came from (paid Google Ads vs organic). gbraid / wbraid
    // are the iOS stand-ins for gclid. First touch is kept in sessionStorage because
    // the enquiry usually happens pages after landing.
    try {
      var qs = new URLSearchParams(location.search);
      var attrib = null;
      try { attrib = JSON.parse(sessionStorage.getItem('ac_attrib') || 'null'); } catch (err) { attrib = null; }
      if (!attrib) {
        attrib = {
          landing: location.pathname + location.search,
          ref: document.referrer || '',
          us: qs.get('utm_source') || '', um: qs.get('utm_medium') || '',
          uc: qs.get('utm_campaign') || '', un: qs.get('utm_content') || '', ut: qs.get('utm_term') || '',
          gclid: qs.get('gclid') || '', gbraid: qs.get('gbraid') || '', wbraid: qs.get('wbraid') || ''
        };
        try { sessionStorage.setItem('ac_attrib', JSON.stringify(attrib)); } catch (err) {}
      }
      var gclCookie = document.cookie.match(/(?:^|; )_gcl_aw=([^;]*)/);
      var gclid = attrib.gclid || (gclCookie ? decodeURIComponent(gclCookie[1]).split('.').slice(2).join('.') : '');
      var bits = [];
      if (attrib.us || attrib.um) bits.push('utm=' + [attrib.us, attrib.um, attrib.uc, attrib.un, attrib.ut].filter(Boolean).join('/'));
      if (gclid) bits.push('gclid=' + gclid);
      if (attrib.gbraid) bits.push('gbraid=' + attrib.gbraid);
      if (attrib.wbraid) bits.push('wbraid=' + attrib.wbraid);
      if (attrib.landing) bits.push('landing=' + attrib.landing);
      if (attrib.ref) bits.push('ref=' + attrib.ref);
      var attribVal = bits.length ? bits.join(' | ') : 'no-attribution-data';
      var attribFields = document.querySelectorAll('[data-attrib-input]');
      for (var ai = 0; ai < attribFields.length; ai++) attribFields[ai].value = attribVal;
    } catch (err) { /* attribution must never break the modals */ }

    // Enhanced conversions for leads (booking form only). Email and phone are
    // normalised the way Google asks — email trimmed and lower-cased, dots before
    // @gmail.com / @googlemail.com dropped; phone in E.164 (04xx → +614xx, or +64
    // for an Auckland booking or the NZ store) — then SHA-256 hashed. Only the hex
    // hashes are kept in sessionStorage (ac_ec_book), never the typed values; the
    // success page hands them to gtag('set', 'user_data') right before the booking
    // conversion and deletes them.
    // Hashing is async, so it runs whenever either field changes (typing, autofill)
    // and again on submit. The submit itself is never held back: Shopify's hCaptcha
    // already cancels every submit event, fetches a token and then posts the form
    // natively, which takes far longer than a hash, and holding and re-posting the
    // form ourselves would race that captcha flow. A submit that reaches the
    // document has passed the booking checks (they stop propagation when a step is
    // missing).
    try {
      if (window.crypto && crypto.subtle && window.TextEncoder && window.Promise) {
        var ecReady = null;  // { key: normalised values, data: hashes }, in memory only
        var ecSeq = 0;
        var ecEmail = function (v) {
          var em = String(v || '').trim().toLowerCase(), at = em.lastIndexOf('@');
          if (at < 1) return '';
          var dom = em.slice(at + 1);
          if (dom === 'gmail.com' || dom === 'googlemail.com') em = em.slice(0, at).replace(/\./g, '') + '@' + dom;
          return em;
        };
        var ecPhone = function (v, nz) {
          var raw = String(v || '').trim(), d = raw.replace(/\D/g, '');
          if (!d) return '';
          if (raw.charAt(0) === '+') { /* already international */ }
          else if (/^00/.test(d)) d = d.slice(2);                       // 0061 … / 0064 …
          else if (/^0/.test(d)) d = (nz ? '64' : '61') + d.slice(1);   // 0412 345 678 → 61412345678
          else if (!/^6[14]/.test(d)) d = (nz ? '64' : '61') + d;       // 412 345 678 (no trunk 0)
          d = d.replace(/^(6[14])0/, '$1');                             // +61 (0)412 … → 61412 …
          return /^[1-9]\d{9,14}$/.test(d) ? '+' + d : '';
        };
        var ecSha = function (s) {
          return crypto.subtle.digest('SHA-256', new TextEncoder().encode(s)).then(function (buf) {
            return Array.prototype.map.call(new Uint8Array(buf), function (b) { return (b < 16 ? '0' : '') + b.toString(16); }).join('');
          });
        };
        var ecHash = function (form, done) {
          var loc = form.querySelector('input[name="contact[Showroom / pickup point]"]:checked');
          var nz = (window.Shopify && Shopify.country === 'NZ') || /auckland|zealand/i.test(loc ? loc.value : '');
          var em = ecEmail((form.elements['contact[email]'] || {}).value);
          var ph = ecPhone((form.elements['contact[phone]'] || {}).value, nz);
          var key = em + '|' + ph;
          if (ecReady && ecReady.key === key) { done(ecReady.data); return; }
          var seq = ++ecSeq;
          Promise.all([em ? ecSha(em) : '', ph ? ecSha(ph) : '']).then(function (h) {
            if (seq !== ecSeq) return;  // a newer edit is already being hashed
            var data = {};
            if (h[0]) data.sha256_email_address = h[0];
            if (h[1]) data.sha256_phone_number = h[1];
            ecReady = { key: key, data: data };
            done(data);
          }).catch(function () {});
        };
        document.addEventListener('change', function (e) {
          try {
            var f = e.target && e.target.form;
            if (!f || f.id !== 'BookingForm' || (e.target.name !== 'contact[email]' && e.target.name !== 'contact[phone]')) return;
            ecHash(f, function () {});
          } catch (err) {}
        });
        document.addEventListener('submit', function (e) {
          try {
            if (!e.target || e.target.id !== 'BookingForm') return;
            ecHash(e.target, function (data) {
              try {
                if (data.sha256_email_address || data.sha256_phone_number) sessionStorage.setItem('ac_ec_book', JSON.stringify(data));
                else sessionStorage.removeItem('ac_ec_book');
              } catch (err) {}
            });
          } catch (err) {}
        });
      }
    } catch (err) { /* enhanced conversions must never block the booking form */ }

    // Google Ads lead conversions — all four are SECONDARY actions ("AC Lead - *" in
    // the Ads account), so they never touch the main Conversions column or bidding.
    // Form conversions fire on the post-submit success page (?contact_posted=true),
    // where the URL hash tells the booking modal (#BookingForm) apart from the
    // contact-page form (#ContactPageForm); with no hash, a page without the
    // contact-page success block can only be a booking submit. mailto:/tel: fire on
    // click. Per-form sessionStorage keys stop success-page reloads from double
    // counting; each new form submission clears its own key first, so a later
    // legitimate booking/contact in the same tab is still counted.
    try {
      var CONV = {
        book: 'DBGGCP-27eUcEIvfxPFD',
        contact: 'yv10CIK37eUcEIvfxPFD',
        email: '_iTLCIW37eUcEIvfxPFD',
        phone: 'XspUCIi37eUcEIvfxPFD'
      };
      var sendConv = function (label, kind) {
        /* belt & braces: make sure the real gtag.js is (being) loaded — the
           stub queues the event in dataLayer and it is replayed on arrival,
           so a conversion can never outrun the lazy loader */
        if (typeof window.acLoadGtag === 'function') window.acLoadGtag();
        if (typeof gtag === 'function') gtag('event', 'conversion', { send_to: 'AW-18223280011/' + label });
      };
      var sessionGet = function (key) {
        try { return sessionStorage.getItem(key); } catch (err) { return null; }
      };
      var sessionSet = function (key) {
        try { sessionStorage.setItem(key, '1'); } catch (err) {}
      };
      var sessionRemove = function (key) {
        try { sessionStorage.removeItem(key); } catch (err) {}
      };
      // A submit that reaches the document is going ahead: the booking checks stop
      // propagation when a step is missing, and Shopify's hCaptcha always cancels
      // the event and posts the form itself once it has a token, so
      // e.defaultPrevented can't tell a blocked submit from a real one.
      document.addEventListener('submit', function (e) {
        var formId = e.target && e.target.id;
        if (formId !== 'BookingForm' && formId !== 'ContactPageForm') return;
        sessionRemove(formId === 'BookingForm' ? 'ac_conv_sent_book' : 'ac_conv_sent_contact');
      });
      if (location.search.indexOf('contact_posted=true') !== -1) {
        var isBook;
        if (location.hash === '#BookingForm') isBook = true;
        else if (location.hash === '#ContactPageForm') isBook = false;
        else isBook = !document.querySelector('.cform__done');
        var convKey = isBook ? 'ac_conv_sent_book' : 'ac_conv_sent_contact';
        if (!sessionGet(convKey)) {
          if (isBook) {
            /* enhanced conversions for leads: the hashes saved when the booking was submitted */
            try {
              var saved = JSON.parse(sessionGet('ac_ec_book') || 'null') || {}, userData = {}, hex = /^[0-9a-f]{64}$/;
              if (hex.test(saved.sha256_email_address)) userData.sha256_email_address = saved.sha256_email_address;
              if (hex.test(saved.sha256_phone_number)) userData.sha256_phone_number = saved.sha256_phone_number;
              if ((userData.sha256_email_address || userData.sha256_phone_number) && typeof gtag === 'function') gtag('set', 'user_data', userData);
            } catch (err) {}
          }
          sendConv(isBook ? CONV.book : CONV.contact, isBook ? 'book' : 'contact');
          sessionSet(convKey);
        }
        if (isBook) sessionRemove('ac_ec_book');
      }
      document.addEventListener('click', function (e) {
        var a = e.target.closest('a[href^="mailto:"], a[href^="tel:"]');
        if (!a) return;
        var isMail = a.getAttribute('href').indexOf('mailto:') === 0;
        sendConv(isMail ? CONV.email : CONV.phone, isMail ? 'email' : 'phone');
      });
    } catch (err) { /* conversions must never break the modals */ }

    // The success state is on screen and the conversion has read the URL by now, so
    // drop ?contact_posted=true and the #BookingForm / #ContactPageForm hash: the
    // address bar goes back to the plain page, and a refresh or shared link doesn't
    // show "Request received" again. Any other query parameters are kept.
    try {
      if (/[?&]contact_posted=/.test(location.search) && window.history && history.replaceState) {
        var cleanUrl = new URL(location.href);
        cleanUrl.searchParams.delete('contact_posted');
        if (cleanUrl.hash === '#BookingForm' || cleanUrl.hash === '#ContactPageForm') cleanUrl.hash = '';
        var cleanQs = cleanUrl.searchParams.toString();
        history.replaceState(history.state, '', cleanUrl.pathname + (cleanQs ? '?' + cleanQs : '') + cleanUrl.hash);
      }
    } catch (err) { /* a tidy URL is cosmetic; never break the page for it */ }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specialist-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-spm]').forEach(function (root) {
      function select(id) {
        var next = root.querySelector('[data-spm-card="' + id + '"]');
        if (!next) return;
        var cur = root.querySelector('.spm__card.is-active');
        root.querySelectorAll('.spm__chip').forEach(function (c) {
          var on = c.getAttribute('data-spm-pick') === id;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        if (cur === next) return;
        if (cur) {
          cur.classList.remove('is-active');
          cur.classList.add('is-leaving');
          setTimeout(function () { cur.classList.remove('is-leaving'); if (!cur.classList.contains('is-active')) cur.hidden = true; }, 320);
        }
        next.hidden = false;
        void next.offsetWidth;
        next.classList.add('is-active');
      }
      root.addEventListener('click', function (e) {
        var pick = e.target.closest('[data-spm-pick]');
        if (pick && root.contains(pick)) select(pick.getAttribute('data-spm-pick'));
      });
      /* the other posters sit in hidden cards, so lazy-loading would leave a blank card on
         first pick: fetch them all once the panel is about to scroll into view */
      function warm() { root.querySelectorAll('.spm__poster-img').forEach(function (img) { img.loading = 'eager'; }); }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries.some(function (en) { return en.isIntersecting; })) { warm(); io.disconnect(); }
        }, { rootMargin: '600px 0px' });
        io.observe(root);
      } else { warm(); }
      /* theme editor: selecting a block shows its card */
      document.addEventListener('shopify:block:select', function (e) {
        var card = e.target.closest && e.target.closest('[data-spm-card]');
        if (card && root.contains(card)) select(card.getAttribute('data-spm-card'));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
